<template>
  <v-app id="main" :style="{ background: $vuetify.theme.current.background }">
    <Sidebar /> <!-- Assuming Sidebar is a separate component -->
    <v-main>
      <RightDrawer />
      <AppBar />
      <router-view /> <!-- This is where your content will load (Dashboard, Settings, etc.) -->
      <FloatForm/>
      <BottomSheet/>
    </v-main>
  </v-app>
</template>

<script>
import Sidebar from '@/components/layout/Sidebar.vue'; // Import Sidebar component
import AppBar from '@/components/layout/AppBar.vue';
import RightDrawer from '@/components/layout/RightDrawer.vue';
import FloatForm from '@/components/layout/FloatForm.vue';
import BottomSheet from '@/components/layout/BottomSheet.vue';

export default {
  name: 'AppView',
  components: {
    Sidebar,
    AppBar,
    RightDrawer,
    FloatForm,
    BottomSheet
  },
};
</script>
